function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React from 'react';
import ErrorIcon from '@atlaskit/icon/core/migration/status-error--error';
import { R300 } from '@atlaskit/theme/colors';
import { fireOperationalAnalytics } from '@atlassian/analytics-bridge';
import { Action, ActionSubject } from '@atlassian/proforma-utils/analytics';
export var loadChoicesAsyncFn = function loadChoicesAsyncFn(jiraFieldsSearchOptionFns, errorUtils, createAnalyticsEvent, showFlag) {
  return function (formStore) {
    return function (questionId, query) {
      try {
        // Find the question and load the search choices.
        var _iterator = _createForOfIteratorHelper(formStore.questions),
          _step;
        try {
          var _loop = function _loop() {
              var questionStore = _step.value;
              if (questionStore.id === questionId && questionStore.formQuestion.jiraField) {
                var _questionStore$issueF, _questionStore$issueF2;
                var searchOptions = ((_questionStore$issueF = questionStore.issueFieldData) === null || _questionStore$issueF === void 0 || (_questionStore$issueF = _questionStore$issueF.schema) === null || _questionStore$issueF === void 0 ? void 0 : _questionStore$issueF.custom) && jiraFieldsSearchOptionFns.custom[questionStore.issueFieldData.schema.custom] || ((_questionStore$issueF2 = questionStore.issueFieldData) === null || _questionStore$issueF2 === void 0 || (_questionStore$issueF2 = _questionStore$issueF2.schema) === null || _questionStore$issueF2 === void 0 ? void 0 : _questionStore$issueF2.system) && jiraFieldsSearchOptionFns.system[questionStore.issueFieldData.schema.system] || undefined;
                if (searchOptions !== undefined) {
                  var searchOptionsFn = searchOptions.searchOptionsFn,
                    onSearchError = searchOptions.onSearchError;
                  return {
                    v: searchOptionsFn(questionStore.formQuestion.jiraField, query, questionStore.issueFieldData, formStore).then(function (options) {
                      var _questionStore$issueF3, _questionStore$issueF4, _questionStore$issueF5;
                      questionStore.setChoices(options.map(function (option) {
                        return {
                          id: option.value,
                          label: option.label,
                          cmdbObject: option.cmdbObject
                        };
                      }));
                      fireOperationalAnalytics(createAnalyticsEvent({}), "".concat(ActionSubject.SEARCH_ASYNC_CHOICES, " ").concat(Action.FINISHED), {
                        schemaKey: (_questionStore$issueF3 = (_questionStore$issueF4 = questionStore.issueFieldData) === null || _questionStore$issueF4 === void 0 || (_questionStore$issueF4 = _questionStore$issueF4.schema) === null || _questionStore$issueF4 === void 0 ? void 0 : _questionStore$issueF4.system) !== null && _questionStore$issueF3 !== void 0 ? _questionStore$issueF3 : (_questionStore$issueF5 = questionStore.issueFieldData) === null || _questionStore$issueF5 === void 0 || (_questionStore$issueF5 = _questionStore$issueF5.schema) === null || _questionStore$issueF5 === void 0 ? void 0 : _questionStore$issueF5.custom
                      });
                      return options;
                    }).catch(function (error) {
                      var _questionStore$issueF6, _questionStore$issueF7, _questionStore$issueF8;
                      errorUtils.reportError(error, {
                        id: ActionSubject.SEARCH_ASYNC_CHOICES,
                        attributes: {
                          schemaKey: (_questionStore$issueF6 = (_questionStore$issueF7 = questionStore.issueFieldData) === null || _questionStore$issueF7 === void 0 || (_questionStore$issueF7 = _questionStore$issueF7.schema) === null || _questionStore$issueF7 === void 0 ? void 0 : _questionStore$issueF7.system) !== null && _questionStore$issueF6 !== void 0 ? _questionStore$issueF6 : (_questionStore$issueF8 = questionStore.issueFieldData) === null || _questionStore$issueF8 === void 0 || (_questionStore$issueF8 = _questionStore$issueF8.schema) === null || _questionStore$issueF8 === void 0 ? void 0 : _questionStore$issueF8.custom
                        }
                      });
                      if (error.error) {
                        // assume ApiError
                        var flag = onSearchError === null || onSearchError === void 0 ? void 0 : onSearchError(error);
                        if (flag) {
                          showFlag({
                            title: flag.title,
                            description: flag.description,
                            icon: /*#__PURE__*/React.createElement(ErrorIcon, {
                              spacing: "spacious",
                              label: "Error",
                              color: "var(--ds-icon-danger, ".concat(R300, ")")
                            }),
                            isAutoDismiss: true
                          });
                        }
                      }
                      return Promise.resolve([]);
                    })
                  };
                }
              }
            },
            _ret;
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _ret = _loop();
            if (_ret) return _ret.v;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        throw new Error('`questionId` not found while trying to load search choices.');
      } catch (error) {
        errorUtils.reportError(error, {
          id: ActionSubject.SEARCH_ASYNC_CHOICES
        });
        return Promise.resolve([]);
      }
    };
  };
};